import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { getLoginToken } from "../storage";
import { queryKeys } from "../react-query/constants";
import { successAlert, toastOptions } from "../utils";
import { toast } from "react-toastify";

const SERVER_ERROR = "There was an error contacting the server.";

async function createQuestionnaire(formData: any) {
  const data = await axiosInstance({
    url: "/onboarding",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useCreateQuestionnaire() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => createQuestionnaire(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.category]);
      successAlert("Questionnaire  created successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function allQuestionnaire() {
  const data = await axiosInstance({
    url: "/onboarding",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useGetQuestionnaire() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.questionnaire],
    queryFn: allQuestionnaire,
  });
  return data;
}

async function updateQuestionnaire(formData: any) {
  const data = await axiosInstance({
    url: `/onboarding/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useUpdateQuestionnaire() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData: any) => updateQuestionnaire(formData),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries([queryKeys.questionnaire]);
      successAlert("Questionnaire  updated successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function deleteQuestionnaire(questionId: string) {
  const data = await axiosInstance({
    url: `/onboarding/${questionId}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useDeleteQuestionnaire() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => deleteQuestionnaire(formData as any),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.questionnaire]);
      successAlert("Questionnaire deleted successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}
